import React, {Component, Fragment, h} from "preact";
import {AppPage} from "../../_common/components/app-page";
import { Form as FinalForm } from 'react-final-form'
import {
    FormFieldSelect,
    FormFieldTextArea,
    UploadFile
} from "../../_common/forms/components/components";
import {Card, CF, E, FR, R} from "../../_common/layout";
import {connect} from "react-redux";
import {fetchFixture, fetchNeeDocumentInfo, saveNeeDocument, downloadNeeDocument} from "../../_rx/student/actions";
import {t} from '../../_i18n';
import {formatDateLong} from "../../utils";
import {ButtonLink, ButtonPrimary} from "../../_common/components/buttons/buttons";
import getLangByShopId from "../../_common/utils/getLang";
import AlertBox from "../../_common/components/AlertBox/AlertBox";

let NeeView = class extends Component {

    constructor(props) {
        super(props);
        this.state = {
            file: null,
            fileUrl: '#',
            loading: false,
            enabledEditData: false,
            dataLoaded: false
        }
    }

    componentDidMount() {
        const {auth} = this.props;
        if(!this.props.fixtures)
            this.props.fetchFixture(getLangByShopId(this.props.status.student_meta.shop_id));

        this.props.fetchNeeDocumentInfo(auth.loggedUser.id).then(() => {
            const { neeDocumentStatus } = this.props;
            if (!neeDocumentStatus?.data || typeof neeDocumentStatus?.data !== "object" || Object.keys(neeDocumentStatus.data).length === 0) {
                this.setState({ enabledEditData: true });
            }
            this.setState({ dataLoaded: true });
        });
    }

    handleUploadFile = async (event) => {
        let eventFile = event.target.files[0];
        this.setState({
            file: eventFile,
            fileURL: URL.createObjectURL(eventFile),
        });
    };

    handleRemoveFile = () => {
        this.setState({
            file: null,
            fileURL: '#',
        });
    };

    onSubmit = async (input) => {
        const { auth } = this.props;
        const { file, enabledEditData } = this.state;
        const hasExistingDocument = this.props.neeDocumentStatus?.data?.documents?.length > 0;
        const { data } = input;

        this.setState({ loading: true });

        try {
            if (enabledEditData) {
                if (file) {
                    data.file = file;
                    data.replica = false;
                } else if (hasExistingDocument) {
                    data.file = null;
                    data.replica = true;
                } else {
                    data.file = file;
                    data.replica = false;
                }
            } else {
                data.file = null;
                data.replica = true
            }

            this.props.saveNeeDocument(auth.loggedUser.id, data);
        } catch (error) {
            console.error('Error subiendo el archivo:', error);
        }

        this.handleRemoveFile();
        this.setState({ loading: false });
    };

    handleCancel(e){
        e.preventDefault()
        this.props.history.goBack()
    }

    handleDownloadFile = async (file) => {
        const { auth } = this.props;
        this.props.downloadNeeDocument(auth.loggedUser.id, file);
    }

    getAlertHTML() {
        const {neeDocumentStatus} = this.props
        if (neeDocumentStatus?.outcome) {
            return (
                <Fragment>
                    <FR><E className='m-top font-bold m-bottom'>{t('Resolución')}:</E></FR>
                    <FR>
                        <E className={'full-width'}>
                            <AlertBox type='shadow' className={'m-r'}>
                                <p>{neeDocumentStatus.outcome}</p>
                            </AlertBox>
                        </E>
                    </FR>
                </Fragment>
            )
        } else if (neeDocumentStatus?.comments) {
            return (
                <FR className='m-top'>
                    <E className={'full-width'}>
                        <AlertBox type={neeDocumentStatus.status_id === 2 ? 'warning' : 'info'} className={'m-r'}>
                            <p>{neeDocumentStatus.comments}</p>
                        </AlertBox>
                    </E>
                </FR>
            )
        }

        return false
    }

    render({fixtures, history, neeDocumentStatus}) {
        const {file, fileURL, loading, enabledEditData, dataLoaded} = this.state;

        return (
            <CF className="max-width m-top-header-xs-sm">
                {!dataLoaded 
                    ? <p className="t-center"><em className="disabled-aspect-gray"> {t('Cargando')}. . . </em></p>
                    : fixtures && neeDocumentStatus &&
                    <Card className="p-bottom">
                        <h1>{t('Necesidades Educativas')}</h1>
                        <FinalForm onSubmit={data => this.onSubmit(data)} initialValues={neeDocumentStatus} render={
                            ({handleSubmit, submitting, errors, submitSucceeded, values, dirty}) => {
                                const hasChanges = dirty || !!file;
                                const isMoreInfoFilled = values.data?.more_info && values.data.more_info.length > 0;

                                const startDate = neeDocumentStatus?.status?.open_date && formatDateLong(neeDocumentStatus.status.open_date);
                                const endDate = neeDocumentStatus?.status?.close_date && formatDateLong(neeDocumentStatus.status.close_date);

                                let datesString = t('nee_dates_string');

                                if (startDate && startDate?.length > 1) {
                                    datesString = datesString.replace('{{start_date}}', `${startDate[0]} de ${startDate[1]} de ${startDate[2]}`)
                                }

                                if (endDate && endDate?.length > 1) {
                                    datesString = datesString.replace('{{end_date}}', `${endDate[0]} de ${endDate[1]} de ${endDate[2]}`)
                                }


                                return <form className='form' action="" onSubmit={handleSubmit} noValidate>
                                    {submitSucceeded && history.goBack()}
                                    {neeDocumentStatus?.status?.enabled && <FR><E className=''>{datesString}</E></FR>}
                                    <FR className='m-top'><E>
                                        <FormFieldSelect
                                            name="data.nee_level_id"
                                            label={t('Selecciona una necesidad educativa')}
                                            required={true}
                                            disabled={!neeDocumentStatus?.status?.enabled || !enabledEditData}
                                            options={fixtures.nee}
                                        />
                                    </E></FR>
                                    {neeDocumentStatus?.status?.enabled &&
                                        <Fragment>
                                            { enabledEditData ?
                                                [
                                                    <FR><E className='m-top font-bold m-bottom'>{t('Subir archivo')}:</E></FR>,
                                                    <FR>
                                                        {!file ?
                                                                <E>
                                                                    <UploadFile
                                                                        classNameButton='btn btn-ghost m-top m-bottom t-upper'
                                                                        accept='application/pdf,.docx,.doc,.odt'
                                                                        onChange={this.handleUploadFile}>
                                                                        {t('Subir archivo')}
                                                                    </UploadFile>
                                                                </E>
                                                                :
                                                                <E className='m-bottom d-flex flex-column sm-no-flex-column'>
                                                                    <a className='m-r font-color-149BAB m-bottom sm-no-m-bottom'
                                                                        href={fileURL}
                                                                        download={file.name}>{file.name}</a>
                                                                    <span
                                                                        className='cursor-pointer font-color-soft-gray t-underline'
                                                                        onClick={this.handleRemoveFile}>{t('Quitar archivo')}</span>
                                                                </E>

                                                        }
                                                    </FR>
                                                ]
                                                :
                                                [
                                                    <FR><E className='m-top font-bold m-bottom'>{t('Documentos subidos')}:</E></FR>,
                                                    neeDocumentStatus?.data?.documents?.map(doc =>
                                                    <FR><E className='m-bottom d-flex flex-column sm-no-flex-column'>
                                                                <span
                                                                    className='cursor-pointer font-color-soft-gray t-underline'
                                                                    onClick={() => this.handleDownloadFile(doc)}
                                                                >{doc?.name}</span>
                                                    </E></FR>),
                                                ]
                                            }
                                            <FR>
                                                <E className='full-width'>
                                                    { enabledEditData ?
                                                        <FormFieldTextArea
                                                            name='data.more_info'
                                                            required={true}
                                                            specificError={t('Añade un mensaje detallado tus necesidades')}
                                                            label={t('Mensaje')}
                                                            placeholder={t('Explícanos con más detalle tus necesidades educativas')}
                                                            disabled={!enabledEditData}
                                                        />
                                                    :
                                                        [
                                                            <FR><E className='m-top font-bold m-bottom'>{t('Mensaje')}:</E></FR>,
                                                            <span>{values?.data?.more_info}</span>
                                                        ]
                                                    }
                                                </E>
                                            </FR>
                                        </Fragment>
                                    }
                                    {this.getAlertHTML()}
                                    <FR className='m-top'>
                                        { enabledEditData ?
                                            <E className='full-width sm-no-full-width'>
                                                <ButtonPrimary className="full-width sm-no-full-width"
                                                                type='submit'
                                                                disabled={!neeDocumentStatus?.status?.enabled || loading || !hasChanges || !isMoreInfoFilled}>
                                                    {loading ? t('Enviando') : t('Guardar')}
                                                </ButtonPrimary>
                                            </E>
                                            :
                                            [
                                                <E className='full-width sm-no-full-width'>
                                                    <ButtonPrimary className="full-width sm-no-full-width"
                                                                    type='button'
                                                                    onClick={() => this.setState({enabledEditData:true})}
                                                                    disabled={loading || !neeDocumentStatus?.status?.enabled}
                                                    >
                                                        {t('Modificar')}
                                                    </ButtonPrimary>
                                                </E>,
                                                <E className='full-width sm-no-full-width'>
                                                    <ButtonPrimary className="full-width sm-no-full-width"
                                                                    type='submit'
                                                                    disabled={!neeDocumentStatus?.status?.enabled || loading || !neeDocumentStatus?.data?.documents || !isMoreInfoFilled}>
                                                        {loading ? t('Enviando') : t('Reenviar')}
                                                    </ButtonPrimary>
                                                </E>
                                            ]
                                        }
                                        <E>
                                            <ButtonLink
                                                className="full-width sm-no-full-width sm-d-block d-none"
                                                onClick={(e) => this.handleCancel(e)}>
                                                {t('Cancelar')}
                                            </ButtonLink>
                                        </E>
                                    </FR>
                                </form>
                            }
                            }
                        />
                    </Card>
                }
            </CF>
        );
    }
};


NeeView = connect(
    ({auth, fixtures, student, status, neeDocumentStatus}) => ({auth, fixtures, student, status, neeDocumentStatus}),
    {
        fetchFixture,
        fetchNeeDocumentInfo,
        saveNeeDocument,
        downloadNeeDocument
    })(NeeView);

const Nee = ({history}) =>
    <AppPage
        name="necesidades-educativas"
        className="max-width"
    >
        <NeeView history={history}/>
    </AppPage>
;

export default Nee;
